import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteeSteps } from '../data/content';
export function Guarantee() {
  return <section className="bg-white px-4 py-6 sm:px-6" data-id="element-75" data-mp="1o33xor06cami">
      <div className="mx-auto max-w-2xl rounded-md border-2 border-teal/50 bg-cream p-4 text-center" data-id="element-76" data-mp="223y639n82bl6">
        <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-teal/15 text-teal" data-id="element-77" data-mp="1x3tpzkq87ivh">
          <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-78" data-mp="19fsjsigisej8" />
        </span>
        <h2 className="mt-2 font-heading text-lg font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-79" data-mp="14g65e5oygs8u">
          Your purchase is 100% protected
        </h2>
        <p className="mt-1.5 text-[13px] font-semibold leading-snug text-graphite sm:text-sm" data-id="element-80" data-mp="1j6dg1z8q16yz">
          Explore SENIOR ACTIVITY READY™ for 14 full days.
        </p>

        <ul className="mt-2.5 grid gap-1 text-left sm:grid-cols-2" data-id="element-81" data-mp="qmyc89l87op1">
          {guaranteeSteps.map(step => <li key={step} className="rounded bg-white px-2.5 py-1.5 text-[12px] font-medium leading-snug text-graphite" data-id="element-82" data-mp="lowkl09qih1y">
              {step}
            </li>)}
        </ul>

        <p className="mt-2.5 text-[12px] font-medium leading-snug text-graphite sm:text-[13px]" data-id="element-83" data-mp="ypb97n3b2jxu">
          If you decide the system isn’t right for you, contact us within 14 days
          for a full refund according to the refund terms.{' '}
          <strong className="font-bold text-navy" data-id="element-84" data-mp="61p5meu2vfaz">
            You can explore the complete system without taking the full risk
            yourself.
          </strong>
        </p>
      </div>
    </section>;
}